export default "__VITE_ASSET__DdC8rp4D__"